// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-content {
  text-align: center;
}

.modal-body {
  margin-bottom: 3rem;
}

.modal-body svg {
  margin-bottom: 1rem;
}

.modal-header, .modal-footer {
  border: none;
}

.fa-exclamation-triangle::before {
  content: none;
}

.verify-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInZlcmlmeS1lbWFpbC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGtCQUFBO0FBQ0Y7O0FBRUE7RUFDRSxtQkFBQTtBQUNGOztBQUVBO0VBQ0UsbUJBQUE7QUFDRjs7QUFFQTtFQUNFLFlBQUE7QUFDRjs7QUFFQTtFQUNFLGFBQUE7QUFDRjs7QUFFQTtFQUNFLGFBQUE7RUFDQSxzQkFBQTtFQUNBLG1CQUFBO0VBQ0Esa0JBQUE7QUFDRiIsImZpbGUiOiJ2ZXJpZnktZW1haWwuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIubW9kYWwtY29udGVudCB7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbn1cblxuLm1vZGFsLWJvZHkge1xuICBtYXJnaW4tYm90dG9tOiAzcmVtO1xufVxuXG4ubW9kYWwtYm9keSBzdmcge1xuICBtYXJnaW4tYm90dG9tOjFyZW07XG59XG5cbi5tb2RhbC1oZWFkZXIsIC5tb2RhbC1mb290ZXIge1xuICBib3JkZXI6IG5vbmU7XG59XG5cbi5mYS1leGNsYW1hdGlvbi10cmlhbmdsZTo6YmVmb3JlIHtcbiAgY29udGVudDogbm9uZTtcbn1cblxuLnZlcmlmeS1jb250YWluZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/components/account/verify-email/verify-email.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AACF;AACA,46BAA46B","sourcesContent":[".modal-content {\n  text-align: center;\n}\n\n.modal-body {\n  margin-bottom: 3rem;\n}\n\n.modal-body svg {\n  margin-bottom:1rem;\n}\n\n.modal-header, .modal-footer {\n  border: none;\n}\n\n.fa-exclamation-triangle::before {\n  content: none;\n}\n\n.verify-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
